<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.1037 2.55947C11.4698 1.81351 12.5331 1.81351 12.8992 2.55947L15.5551 7.97195L21.5058 8.8416C22.3242 8.96121 22.6519 9.96613 22.0612 10.5452L17.7514 14.7703L18.7676 20.7291C18.9071 21.5467 18.0477 22.1689 17.3144 21.7812L12.0014 18.972L6.68849 21.7812C5.9552 22.1689 5.09584 21.5467 5.23529 20.7291L6.25145 14.7703L1.94166 10.5452C1.35101 9.96613 1.67867 8.96121 2.49711 8.8416L8.44775 7.97195L11.1037 2.55947Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'StarFilled'
};
</script>

<style lang="scss" scoped>
svg path {
  fill: $primary;
}
</style>
